import React from "react";
import { Warning } from "@phosphor-icons/react";
import { Sentry } from "@/lib/sentry";

function ErrorFallback({ error, onReset }) {
  const isDev = process.env.NODE_ENV === "development";

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 to-white p-4">
      <div className="bg-white rounded-3xl border border-gray-200 shadow-xl max-w-md w-full p-8 text-center space-y-5">
        <div className="mx-auto w-16 h-16 rounded-2xl bg-amber-100 flex items-center justify-center">
          <Warning size={36} weight="duotone" className="text-amber-600" />
        </div>

        <div>
          <h1 className="text-xl font-heading font-semibold text-gray-900">
            Oops, quelque chose s'est mal passé
          </h1>
          <p className="text-sm text-gray-500 mt-2">
            Une erreur inattendue s'est produite. Veuillez réessayer.
          </p>
        </div>

        {isDev && error && (
          <pre className="text-left text-xs bg-red-50 text-red-800 rounded-xl p-4 overflow-auto max-h-40 border border-red-200">
            {error.message || String(error)}
          </pre>
        )}

        <div className="flex flex-col gap-3">
          <button
            onClick={() => window.location.reload()}
            className="w-full py-3 rounded-xl bg-[color:var(--brand)] text-white font-semibold hover:bg-[color:var(--brand-hover)] transition-colors press-scale"
          >
            Recharger la page
          </button>
          <a
            href="/"
            className="text-sm text-[color:var(--brand)] font-medium hover:underline"
          >
            ← Retour à l'accueil
          </a>
        </div>

        <p className="text-[10px] uppercase tracking-widest font-bold text-gray-300">
          Quantelys
        </p>
      </div>
    </div>
  );
}

export default class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
    // Report to Sentry
    Sentry.captureException(error, { extra: { componentStack: errorInfo?.componentStack } });
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorFallback
          error={this.state.error}
          onReset={() => this.setState({ hasError: false, error: null })}
        />
      );
    }
    return this.props.children;
  }
}
